module.exports = __webpack_public_path__ + "img/arrow-down.9092f156.svg";